import { render, staticRenderFns } from "./detailsTab.vue?vue&type=template&id=7444be16&"
import script from "./detailsTab.vue?vue&type=script&lang=js&"
export * from "./detailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports